import React from 'react'
import TabLinkUI from "../../../../widgets/output/TabLinkUI"
import './MasterTemplateNav.css'

const MasterLoanAgrEscrowNavUI = ({ context, page }) =>
  <div className='g_flex_h g_flex_wrap g_flex_left g_p_left_100 master-template-nav-tertiary g_m_top_25'>
    <TabLinkUI label='Escrow Terms' to='/su/master/loanAgreement/escrow' active={page === 'escrow'} />
    <TabLinkUI label='Special Terms' to='/su/master/loanAgreement/sp' active={page === 'sp'} />
    <TabLinkUI label='Escrow and Special Terms' to='/su/master/loanAgreement/escrow_sp' active={page === 'escrow_sp'} />
  </div>

export default MasterLoanAgrEscrowNavUI
